module.exports = __webpack_public_path__ + "static/media/tf.532e5dcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/tf.png
// module id = 1994
// module chunks = 0